var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 106.2,
    cy: 443.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.2,
    cy: 556.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.2,
    cy: 781.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.8,
    cy: 106.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.8,
    cy: 218.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.8,
    cy: 331.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.8,
    cy: 443.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.8,
    cy: 668.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.8,
    cy: 781.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.2,
    cy: 106.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.2,
    cy: 443.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.2,
    cy: 893.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.8,
    cy: 106.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.8,
    cy: 331.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443.8,
    cy: 781.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.2,
    cy: 443.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.2,
    cy: 556.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.2,
    cy: 668.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.2,
    cy: 781.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.2,
    cy: 893.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 668.8,
    cy: 106.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 668.8,
    cy: 443.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 668.8,
    cy: 668.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 781.2,
    cy: 331.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 781.2,
    cy: 443.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.8,
    cy: 106.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.8,
    cy: 218.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.8,
    cy: 331.2,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.8,
    cy: 443.8,
    r: 56.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 893.8,
    cy: 893.8,
    r: 56.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2);
export default __webpack_public_path__ + "static/media/P2.c2ec694c1804c70f723f632a1f618cac.svg";
export { ForwardRef as ReactComponent };